import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import MovieIcon from '@material-ui/icons/Movie';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { DeleteForever } from '@material-ui/icons';
import { ToastContainer, toast } from 'react-toastify';
import api from '../../../services/api';

const useStyles = makeStyles(() => ({
  actions: {
    display: 'none',
    flexDirection: 'column',
    gap: '0.5rem',
    position: 'absolute',
    top: 0,
    right: 0,
    marginTop: '0.2rem',
    marginRight: '0.2rem',
    zIndex: 2,
  },
  actionButton: {
    border: 'none',
    height: 30,
    width: 30,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  previewRow: {
    display: 'flex',
    gap: 16,
    marginTop: 16,
    cursor: 'pointer',
  },
  previewBox: {
    width: 130,
    height: 130,
    borderRadius: 8,
    background: '#F5F5F5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    position: 'relative',
    cursor: 'pointer',
    transition: 'opacity 0.2s',
    '&:hover $overlay': {
      opacity: 1,
    },
    '&:hover $actions': {
      display: 'flex',
    },
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0,0,0,0.45)',
    opacity: 0,
    transition: 'opacity 0.2s',
    borderRadius: 8,
    zIndex: 1,
    pointerEvents: 'none',
  },
  previewImg: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
    border: 'none',
    borderRadius: 0,
  },
  previewText: {
    fontFamily: 'Nunito',
    fontWeight: 700,
    color: '#EC660C',
    fontSize: 16,
    textAlign: 'center',
  },
  fileName: {
    marginTop: 8,
    maxWidth: 100,
    minWidth: 80,
    textAlign: 'center',
    fontFamily: 'Nunito',
    fontWeight: 500,
    fontSize: 14,
    borderBottom: '1px dashed #ccc',
    outline: 'none',
    cursor: 'text',
    wordBreak: 'break-word',
    whiteSpace: 'pre-line',
    overflowWrap: 'break-word',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  title: {
    fontFamily: 'Nunito',
    fontWeight: 700,
    fontStyle: 'bold',
    fontSize: 16,
    lineHeight: '100%',
    letterSpacing: 0,
    margin: 0,
  },
  fileInput: {
    display: 'none',
  },
  customButton: {
    borderRadius: 5,
    padding: '6px 16px',
    background: '#EC660C',
    color: '#fff',
    fontWeight: 700,
    fontFamily: 'Nunito',
    fontSize: 16,
    border: 'none',
    cursor: 'pointer',
    transition: 'background 0.3s',
    marginLeft: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    opacity: 1,
    '&:hover': {
      background: '#d45a0b',
    },
  },
}));

export function Attachments({ onFilesChange, existingFiles, newsId }) {
  const [files, setFiles] = useState([]);
  const [localExistingFiles, setLocalExistingFiles] = useState([]);

  function getFileType(file) {
    if (file.type?.startsWith('image/')) return 'image';
    if (file.type?.startsWith('video/')) return 'video';
    if (file.type === 'application/pdf') return 'pdf';
    return 'other';
  }
  const classes = useStyles();

  useEffect(() => {
    onFilesChange(files);
  }, [files, onFilesChange]);

  useEffect(() => {
    setLocalExistingFiles(existingFiles);
  }, [existingFiles]);

  async function handleDeleteExisting(idx) {
    const item = localExistingFiles[idx];
    if (!item || !newsId) return;
    try {
      await api.delete(`noticias/${newsId}/anexos?id=${item.id}`);
      const updated = [...localExistingFiles];
      updated.splice(idx, 1);
      setLocalExistingFiles(updated);
      toast('Anexo deletado', {
        position: 'bottom-right',
        hideProgressBar: true,
      });
    } catch (e) {
      toast('Erro ao deletar anexo', {
        position: 'bottom-right',
        hideProgressBar: true,
        type: 'error',
      });
    }
  }

  function handleFileChange(e) {
    const selectedFiles = Array.from(e.target.files).map((f) => ({
      file: f,
      name: f.name,
    }));
    setFiles((prev) => [...prev, ...selectedFiles]);
  }

  function handleNameChange(idx, newName) {
    setFiles((files) =>
      files.map((item, i) => (i === idx ? { ...item, name: newName } : item))
    );
  }

  function handleDeleteNew(idx) {
    const updated = [...files];
    updated.splice(idx, 1);
    setFiles(updated);
    toast('Anexo removido', {
      position: 'bottom-right',
      hideProgressBar: true,
    });
  }

  // async function handleNameChangeExisting(idx, newName) {
  //   const item = localExistingFiles[idx];
  //   if (!item || !newsId) return;
  //   try {
  //     await api.put(`noticias/${newsId}/anexos`, {
  //       anexoId: item.id,
  //       nome: newName,
  //     });
  //     const updated = [...localExistingFiles];
  //     updated[idx] = { ...item, name: newName };
  //     setLocalExistingFiles(updated);
  //     toast('Nome do anexo atualizado', {
  //       position: 'bottom-right',
  //       hideProgressBar: true,
  //     });
  //   } catch (e) {
  //     toast('Erro ao atualizar nome do anexo', {
  //       position: 'bottom-right',
  //       hideProgressBar: true,
  //       type: 'error',
  //     });
  //   }
  // }

  return (
    <div>
      <ToastContainer />
      <div className={classes.container}>
        <h4 className={classes.title}>Galeria de arquivos</h4>
        <input
          accept="image/*,application/pdf,video/*"
          className={classes.fileInput}
          id="file-upload"
          type="file"
          multiple
          onChange={handleFileChange}
        />
        <label htmlFor="file-upload" style={{ marginLeft: 8 }}>
          <span className={classes.customButton} tabIndex={0} role="button">
            Novo arquivo
          </span>
        </label>
      </div>

      {/* Grid única para todos os arquivos */}
      <div className={classes.previewRow}>
        {localExistingFiles.map((item, idx) => {
          const ext = item.name?.split('.').pop()?.toLowerCase();
          const type =
            ext === 'pdf' ? 'pdf' : ext === 'mp4' ? 'video' : 'image';
          return (
            <div
              key={`existing-${idx}`}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <div
                className={classes.previewBox}
                style={{ position: 'relative' }}
              >
                <div className={classes.overlay}></div>
                {type === 'image' ? (
                  <img
                    src={item.url}
                    alt={item.name}
                    className={classes.previewImg}
                  />
                ) : type === 'video' ? (
                  <MovieIcon style={{ fontSize: 32, color: '#EC660C' }} />
                ) : type === 'pdf' ? (
                  <PictureAsPdfIcon
                    style={{ fontSize: 32, color: '#EC660C' }}
                  />
                ) : null}
                <div className={classes.actions}>
                  <button
                    className={classes.actionButton}
                    onClick={() => handleDeleteExisting(idx)}
                  >
                    <DeleteForever
                      htmlColor="#d50000"
                      style={{ height: 20, width: 20 }}
                    />
                  </button>
                </div>
              </div>
              {/* <p
                contentEditable
                suppressContentEditableWarning
                className={classes.fileName}
                onBlur={(e) =>
                  handleNameChangeExisting(idx, e.target.innerText)
                }
                onInput={(e) =>
                  handleNameChangeExisting(idx, e.currentTarget.innerText)
                }
                style={{ cursor: 'default' }}
              >
                {item.name}
              </p> */}
            </div>
          );
        })}
        {/* Depois os arquivos novos (adicionados agora) */}
        {files.map((item, idx) => {
          const type = getFileType(item.file);
          return (
            <div
              key={`new-${idx}`}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <div
                className={classes.previewBox}
                style={{ position: 'relative' }}
              >
                <div className={classes.overlay}></div>
                {type === 'image' ? (
                  <img
                    src={URL.createObjectURL(item.file)}
                    alt={item.name}
                    className={classes.previewImg}
                  />
                ) : type === 'video' ? (
                  <MovieIcon style={{ fontSize: 32, color: '#EC660C' }} />
                ) : type === 'pdf' ? (
                  <PictureAsPdfIcon
                    style={{ fontSize: 32, color: '#EC660C' }}
                  />
                ) : null}
                <div className={classes.actions}>
                  {/* <button className={classes.actionButton}>
                    <RemoveRedEye
                      htmlColor="#003407"
                      style={{ height: 20, width: 20 }}
                    />
                  </button> */}
                  <button
                    className={classes.actionButton}
                    onClick={() => handleDeleteNew(idx)}
                  >
                    <DeleteForever
                      htmlColor="#d50000"
                      style={{ height: 20, width: 20 }}
                    />
                  </button>
                </div>
              </div>
              <p
                contentEditable
                suppressContentEditableWarning
                className={classes.fileName}
                onBlur={(e) => handleNameChange(idx, e.target.innerText)}
                onInput={(e) =>
                  handleNameChange(idx, e.currentTarget.innerText)
                }
              >
                {item.name}
              </p>
            </div>
          );
        })}
      </div>

      {/* Galeria modal (reutilize GalleryModal se já existir) */}
      {/* Exemplo: */}
      {/* <GalleryModal open={galleryOpen} onClose={() => setGalleryOpen(false)} files={galleryFiles} initialIndex={galleryIndex} /> */}
    </div>
  );
}
